import type { WidgetProps } from '@rjsf/utils'
import { useSkrottlappScan } from '../../../hooks/useSkrottlappScan'
import { Mtds } from 'prove-common'

export const EntityIdWidget = ({
  className,
  disabled,
  id,
  onChange,
  placeholder,
  readonly,
  required,
  schema,
  value = ''
}: WidgetProps) => {
  const skrottlappScan = useSkrottlappScan()
  return (
    <Mtds.Field
      aria-labelledby={`${id}_label`}
      as='input'
      className={className}
      disabled={disabled || skrottlappScan?.hasScanned}
      id={id}
      inputMode='numeric'
      maxLength={schema.maxLength}
      minLength={schema.minLength}
      onChange={({ target }) => onChange(target.value)}
      pattern={schema.pattern}
      placeholder={placeholder}
      readOnly={readonly}
      required={required}
      type='text'
      value={value}
    />
  )
}
